import api from '../../../core/api/api';

export const pagosFacturasAPI = {
  listarFacturas: (params) =>
    api.get('/Billing/ListarFacturasOS', { params }).then(r => r.data),

  adjuntarConstancia: (formData) =>
    api.post('/Billing/AdjuntarConstanciaPago', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data),

  verConstancia: (idConstancia) =>
    api.get(`/Billing/VerConstanciaPago/${idConstancia}`, { responseType: 'blob' }),

  getEntidadesFacturacion: () =>
    api.get('/Billing/EntidadesFacturacion').then(r => r.data),
};
